var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/HubManagement/HubManagementConnect.ts";
import "core-js/modules/es.array.concat.js";
import { buildRequestParams } from '@gmini/utils';
import { HubManagement } from './HubManagement';
import { Attribute } from './Attribute';
export function hubManagementConnect(fetchService) {
  HubManagement.Company.fetch.use(function (_ref) {
    var companyId = _ref.companyId;
    return fetchService.get("/v1/companies/".concat(companyId)).then(HubManagement.Company.fetch.toPromise);
  });
  HubManagement.Company.fetchList.use(function () {
    return fetchService.get("/v1/companies").then(HubManagement.Company.fetchList.toPromise);
  });
  Attribute.fetchAttribute.use(function (_ref2) {
    var attrId = _ref2.attrId,
        archived = _ref2.archived;
    return fetchService.get("/v1/attributes/".concat(attrId, "?").concat(buildRequestParams({
      archived: archived
    }))).then(Attribute.fetchAttribute.toPromise);
  });
  Attribute.fetchAttributeValues.use(function (_ref3) {
    var valueIds = _ref3.valueIds;
    return fetchService.post("/v1/attributes/values", {
      ids: valueIds
    }).then(Attribute.fetchAttributeValues.toPromise);
  });
  Attribute.fetchAttributePopulated.use(function (_ref4) {
    var attrId = _ref4.attrId,
        archived = _ref4.archived;
    return fetchService.get("/v1/attributes/".concat(attrId, "/populated?").concat(buildRequestParams({
      archived: archived
    }))).then(Attribute.fetchAttributePopulated.toPromise);
  });
  Attribute.fetchAttributeList.use(function (props) {
    return fetchService.get("/v1/attributes?".concat(buildRequestParams(props))).then(Attribute.fetchAttributeList.toPromise);
  });
}